import { useEffect, useState } from "react";
import { useAuth } from "./contexts/AuthContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AppLayout from "./components/layout/AppLayout";
import DashboardPage from "./pages/DashboardPage";
import AgendaPage from "./pages/AgendaPage";
import RoteirosPage from "./pages/RoteirosPage";
import ClientesPage from "./pages/ClientesPage";
import FornecedoresPage from "./pages/FornecedoresPage";
import FinanceiroPage from "./pages/FinanceiroPage";
import ContasReceberPage from "./pages/ContasReceberPage";
import ContasPagarPage from "./pages/ContasPagarPage";
import ExtratoPage from "./pages/ExtratoPage";
import RelatoriosPage from "./pages/RelatoriosPage";
import PerfilPage from "./pages/PerfilPage";
import SitePublicoPage from "./pages/SitePublicoPage";
import SolicitacoesPage from "./pages/SolicitacoesPage";
import AdminGuiasPage from "./pages/AdminGuiasPage";

// Roteamento simples por estado — segue o padrão do JSX de referência.
// Se o app crescer, migrar para react-router-dom é direto: cada `case` vira
// uma <Route element={...} />.
export default function App() {
  const { user, isOwner } = useAuth();
  const [page, setPage] = useState("dashboard");
  // Tela pré-login: alterna entre login e register. Reset pra "login" sempre
  // que o user some (logout ou token expirado), garantindo que a próxima
  // sessão sem auth comece em LoginPage.
  const [authView, setAuthView] = useState("login");

  useEffect(() => {
    if (!user) setAuthView("login");
  }, [user]);

  // Self-correct de rota owner-only: se o page atual exige Owner e o usuário
  // não é (ex.: troca de sessão sem reload — App não desmonta, page persiste),
  // reseta pra dashboard. Sem isso o state ficaria preso num valor que o render
  // só trata via fallback, deixando o menu sem item ativo.
  useEffect(() => {
    if (page === "admin-guias" && !isOwner) setPage("dashboard");
  }, [page, isOwner]);

  if (!user) {
    if (authView === "register") {
      return <RegisterPage onGoToLogin={() => setAuthView("login")} />;
    }
    return <LoginPage onGoToRegister={() => setAuthView("register")} />;
  }

  return (
    <AppLayout page={page} onNavigate={setPage}>
      {renderPage(page, setPage, isOwner)}
    </AppLayout>
  );
}

function renderPage(page, onNavigate, isOwner) {
  switch (page) {
    case "agenda":
      return <AgendaPage />;
    case "roteiros":
      return <RoteirosPage />;
    case "clientes":
      return <ClientesPage />;
    case "fornecedores":
      return <FornecedoresPage />;
    case "financeiro":
      return <FinanceiroPage />;
    case "contas-receber":
      return <ContasReceberPage />;
    case "contas-pagar":
      return <ContasPagarPage />;
    case "extrato":
      return <ExtratoPage />;
    case "relatorios":
      return <RelatoriosPage />;
    case "perfil":
      return <PerfilPage />;
    case "site-publico":
      return <SitePublicoPage />;
    case "solicitacoes":
      return <SolicitacoesPage />;
    case "admin-guias":
      // Guard de frontend: só Owner renderiza a cabine admin. Não-owner que
      // chegar aqui (sem o item de menu) cai no dashboard. Backend é o gate real.
      return isOwner ? <AdminGuiasPage /> : <DashboardPage onNavigate={onNavigate} />;
    case "dashboard":
    default:
      // onNavigate passado pro dashboard poder levar o user pros cards de Contas
      // quando houver atrasos (commit 2). Outras páginas usam o menu lateral.
      return <DashboardPage onNavigate={onNavigate} />;
  }
}
